'use client';

import React from 'react';

import { Input } from '@eliadmin/core/src/components/ui/input';
import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function AttributePrice() {
  const { t } = useTranslations();
  const max = useCategoryStore(state => state.category.price.max);
  const min = useCategoryStore(state => state.category.price.min) ?? 0;
  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const [priceRange, setPriceRange] = React.useState<number[]>([min ?? 0, max ?? 100000]);
  const currency = useGlobalStore(s => s.generalLayout.currency);

  const setFilter = useCategoryStore(state => state.setFilter);

  React.useEffect(() => {
    setPriceRange([min ?? 0, max ?? 100000]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTrigger]);

  const handlePriceChange = () => {
    setFilter({ price_min: priceRange[0], price_max: priceRange[1] });
  };

  if (max === null) return null;

  return (
    <div className={cn('flex flex-col gap-3 py-2', 'ea-attribute-price')}>
      <Slider
        isDual
        value={priceRange}
        min={min}
        max={max}
        aria-label={t('text4051')}
        onValueChange={value => setPriceRange(value)}
        onBlur={handlePriceChange}
        className=""
      />
      <div
        className={cn('flex w-full flex-row justify-between gap-2', 'ea-attribute-price__wrapper')}
      >
        <Input
          className={{
            wrapper: cn('w-fit border-none p-0 text-left', 'ea-attribute-radio__input-min'),
            main: 'border-none p-0 text-sm font-light sm:text-base',
          }}
          name={'min'}
          variant={'outlined'}
          value={`${priceRange[0]} ${currency}`}
          disabled
        />
        <Input
          className={{
            wrapper: cn('w-fit border-none p-0 text-right', 'ea-attribute-radio__input-max'),
            main: 'w-fit border-none p-0 text-sm font-light sm:text-base',
          }}
          name={'max'}
          variant={'outlined'}
          value={`${priceRange[1]} ${currency}`}
          disabled
        />
      </div>
    </div>
  );
}
